<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
        >
          新增
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.id === '' ? '新增' : '修改') + '渠道'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="渠道名">
          <el-input v-model="formData.channelName"></el-input>
        </el-form-item>
        <el-form-item label="渠道编码">
          <el-input v-model="formData.channelCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      formData: {
        id: "",
        channelCode: "",
        channelName: "",
        channelTypeStr: "2",
        channelStateStr: "0",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "渠道名",
          width: 200,
          fixed: "left",
          key: "channelName",
          align: "center",
        },
        {
          title: "渠道编码",
          width: 200,
          fixed: "left",
          key: "channelCode",
          align: "center",
        },
        {
          title: "渠道类型",
          width: 200,
          fixed: "left",
          key: "channelTypeStr",
          align: "center",
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "修改时间",
          width: 180,
          key: "gmtModified",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </el-button>
              );
            }
            if (this.$hasPermission(this.$route, "delete")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.delete.bind(this, data)}
                >
                  删除
                </el-button>
              );
            }
            return operation;
          },
        },
      ],
      filterObj: {
        channelName: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions("channelStore", {
      list: "listChannel",
      addOrModify: "addOrModifyChannel",
      deleteChannel: "deleteChannel",
    }),
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.id = data.id;
        this.formData.channelCode = data.channelCode;
        this.formData.channelName = data.channelName;
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.addOrModify({
        request: JSON.stringify({ channelItem: this.formData }),
      }).then((res) => {
        if (res.value) {
          this.showFormDialog = !this.showFormDialog;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    delete(data) {
      this.$confirm("确认删除", "警告", {
        confirmButtonText: "狠心删除",
        cancelButtonText: "放弃",
      })
        .then(() => {
          this.deleteChannel({ request: JSON.stringify({ id: data.id }) })
            .then((res) => {
              this.$message.success("删除成功");
              this.fetch();
            })
            .catch((eror) => {
              this.$message.error("未知异常");
            });
        })
        .catch(() => {});
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "渠道名",
              model: "channelName",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>
